module.exports = __webpack_public_path__ + "media/images/university_logos/St-Georges-University-of-London-c1422f5ed396268053a02e4003339ffa.svg";